import { render, staticRenderFns } from "./FeaturesTable.vue?vue&type=template&id=213161f4&"
import script from "./FeaturesTable.vue?vue&type=script&lang=js&"
export * from "./FeaturesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports